import React from "react";
import type { TeamSelectorProps } from "./types";
import { TeamIdentityHeader } from "../ui/TeamIdentityHeader";

export const TeamSelector: React.FC<TeamSelectorProps> = ({
  teamCode,
  standingsMap,
  roundLabels,
  isLoading,
  error,
}) => {
  const selectedStanding = teamCode ? standingsMap.get(teamCode) : null;
  const teamDisplayName = selectedStanding?.team_name || teamCode || "";
  const roundName = selectedStanding?.current_round
    ? (roundLabels[selectedStanding.current_round] || selectedStanding.current_round)
    : "";
  const fallbackStreak =
    selectedStanding && (selectedStanding.current_round_wins > 0 || selectedStanding.current_round_looses > 0)
      ? [
          ...Array(selectedStanding.current_round_wins).fill("W"),
          ...Array(selectedStanding.current_round_looses).fill("L"),
        ]
      : [];
  const streakEntries =
    selectedStanding?.current_round_streak && selectedStanding.current_round_streak.length > 0
      ? selectedStanding.current_round_streak
      : fallbackStreak;

  return (
    <div className="relative">
      <div
        className="flex items-center gap-3 rounded-2xl border border-border bg-background-card p-3.5"
      >
        <div className="min-w-0 flex-1">
          {teamCode && selectedStanding ? (
            <TeamIdentityHeader
              teamCode={selectedStanding.team_code ?? teamCode}
              teamName={teamDisplayName}
              teamPrimaryColor={selectedStanding.team_primary_color ?? null}
              teamSecondaryColor={selectedStanding.team_secondary_color ?? null}
              opponentCode={selectedStanding.opponent_team_code ?? null}
              lastTradePrice={selectedStanding.last_trade_price}
              lastTradeTrend={selectedStanding.last_trade_trend}
              floorPrice={selectedStanding.market_floor_price ?? 0}
              roundText={roundName ? roundName.toUpperCase() : null}
              seriesScore={`${selectedStanding.current_round_wins}-${selectedStanding.current_round_looses}`}
              streakEntries={streakEntries}
              showStatus={false}
              showStreak
              streakVariant="tokens"
              badgeSize={58}
              nameClassName="font-display text-[23px] font-bold uppercase leading-none text-foreground md:text-[24px]"
              metaClassName="font-mono text-sm text-foreground-subtle"
            />
          ) : (
            <span className="text-sm text-slate-400">
              {isLoading ? "Loading teams..." : "Select a team"}
            </span>
          )}
        </div>
      </div>

      {/* Team Error */}
      {error && <p className="text-xs text-amber-400 mt-1">{error}</p>}
    </div>
  );
};
